export class CookieKeys {
  static readonly CAMPUS_MODAL = 'MILTENYI_APPLICATION'
  static readonly MILTENYI_COUNTRY = 'MILTENYI_COUNTRY'
  static readonly MILTENYI_SELECT_COUNTRY = 'MILTENYI_SELECT_COUNTRY'
  static readonly NAVIGATION_COUNTRY = 'NAVIGATION_COUNTRY'
  static readonly MILTENYI_COUNTRY_ORIGIN = 'MILTENYI_COUNTRY_ORIGIN'
  static readonly COUNTRY_REDIRECTED = 'COUNTRY_REDIRECTED'
}
